/**
 * Badge de statut réutilisable (PROD-READY, STAGING, NOT-READY, etc.).
 */
type StatusVariant = 'success' | 'warning' | 'danger' | 'info';

export class StatusBadge extends HTMLElement {
  static get observedAttributes(): string[] {
    return ['variant', 'label'];
  }

  connectedCallback(): void {
    this.render();
  }
  attributeChangedCallback(): void {
    this.render();
  }

  private render(): void {
    const variant = (this.getAttribute('variant') ?? 'info') as StatusVariant;
    const label = this.getAttribute('label') ?? '';
    const colors: Record<StatusVariant, { bg: string; fg: string }> = {
      success: { bg: '#d4edda', fg: '#155724' },
      warning: { bg: '#fff3cd', fg: '#856404' },
      danger: { bg: '#f8d7da', fg: '#721c24' },
      info: { bg: '#d1ecf1', fg: '#0c5460' },
    };
    const colorScheme = colors[variant];
    this.innerHTML = `
      <span style="display:inline-block;padding:2px 10px;border-radius:12px;font-size:0.75rem;font-weight:600;background:${colorScheme.bg};color:${colorScheme.fg};">${label}</span>
    `;
  }
}

customElements.define('nexxus-status-badge', StatusBadge);
